import React, {Component} from 'react';
import {FormGroup, FormControl, ControlLabel, Col} from 'react-bootstrap';
import {default as ReactSelect} from "react-select";

export default class SelectField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			title,
			meta: {error, warning, touched},
			multi,
			emptyText,
			sizes,
			clearable = false,
			onChangeHook,
			...props
		} = this.props;

		let message;
		const validationState = touched ? ( error && "error" ) || ( warning && "warning" ) || null : null;

		if (touched && ( error || warning )) {
			message = <span className="help-block">{error || warning}</span>;
		}

		return (
			<FormGroup controlId={input.name} validationState={validationState} title={title}>
				{label && <Col sm={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col>}
				<Col sm={label ? (sizes && sizes[1] ? sizes[1] : 8) : 12}>
					<ReactSelect
						name={input.name}
						clearable={clearable}
						backspaceRemoves={false}
						deleteRemoves={false}
						multi={multi}
						simpleValue={true}
						clearValueText="Vymazat"
						clearAllText="Vymazat vše"
						noResultsText="(nic nenalezeno)"
						placeholder={emptyText || (props.disabled ? "(není)" : "Vyberte" + (multi ? ' jeden či více' : ''))}
						{...props} {...input}
						onChange={(event) => {
							if (onChangeHook) {
								onChangeHook(event)
							}
							input.onChange(event)
						}}
						onBlur={() => input.onBlur(input.value)}
						value={input.value || (input.value === 0 ? 0 : "")}
					>
					</ReactSelect>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/SelectField.js